import { registerLocaleData } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import {
  inject,
  LOCALE_ID,
  NgModule,
  provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import Lara from '@primeuix/themes/lara';
import { definePreset } from '@primeuix/themes';
import { providePrimeNG } from 'primeng/config';
import { AppComponent } from './app.component';
import { MemberAreaDetailsComponent } from './components/bed-institut-wissen/member-areas/details/details.component';
import { InstitutWissenModule } from './modules/institut-wissen.module';
import { SharedModule } from './modules/shared-module';
import { AuthService } from './services/auth.service';

registerLocaleData(localeDe);

const InwiPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}',
    },
  },
});

@NgModule({
  declarations: [AppComponent, MemberAreaDetailsComponent],
  bootstrap: [AppComponent],
  imports: [BrowserModule, SharedModule, InstitutWissenModule],
  providers: [
    providePrimeNG({
      theme: {
        preset: InwiPreset,
        options: {
          darkModeSelector: false,
          cssLayer: { name: 'primeng', order: 'theme, base, primeng' },
        },
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'de-DE' },
    AuthService,
    provideAppInitializer(() => inject(AuthService).checkSession()),
  ],
})
export class AppModule {}
